import { isMockServices } from 'src/utils';
import { QueryFunction } from '@tanstack/react-query';
import mock from '../utils/mock';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import { ChecklistSyncJob } from './syncTypes';

interface ChecklistSyncStatusResponse {
  success: boolean;
  job: ChecklistSyncJob | null;
}

const getChecklistSyncStatus: QueryFunction<
  ChecklistSyncJob | null,
  ['/tenant/checklist/sync-status', string]
> = async ({ queryKey }) => {
  if (isMockServices()) return await mock(null);

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<ChecklistSyncStatusResponse>(
    `/checklist-rules/${queryKey[1]}/sync-status`,
    { method: 'GET' },
  );

  if (response.data) return response.data.job ?? null;

  throw new Error('Failed to fetch checklist sync status');
};

export default getChecklistSyncStatus;
